import store from '../store';
import { config, updateSessionToken } from './utils';
import * as Keycloak from 'keycloak-js';

export default {
  authenticate: async () => {

    store.state.keycloak = Keycloak(await config('keycloak'));
    const keycloak = store.state.keycloak;

    keycloak.onTokenExpired = async () => {
      const refreshed = await keycloak.updateToken(5);
      if (refreshed) {
        await updateSessionToken();
      } else {
        location.href = keycloak.createLoginUrl();
      }
    }

    const authenticated = await keycloak.init({ onLoad: 'login-required' });

    return new Promise(resolve => {
      if (authenticated) {
        updateSessionToken();
        resolve(true);
      } else {
        resolve(false);
      }
    });
  },

  logout: () => store.state.keycloak.createLogoutUrl(),

  user: async () => {
    const { name, email, sub, realm_access } = await store.state.keycloak.loadUserInfo();
    const { username, attributes } = await store.state.keycloak.loadUserProfile();

    const user = {
      name,
      username,
      login: email,
      image: attributes.image ? attributes.image[0]: null,
      userId: sub,
      permissions: realm_access.roles
    }

    return new Promise(resolve => {
      store.state.user = user;
      resolve(user);
    });
  }
}